/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  useDisclosure,
  HStack,
  Text,
  Icon,
  Stack,
  Button,
  Link,
  Box,
  Flex,
  useTimeout,
} from '@chakra-ui/react';
import { GiCookie } from 'react-icons/gi';
import { useHistory } from 'react-router-dom';
import { useRouteHelper } from '../../../hooks/routesHelpers';
import { useTranslation } from 'react-i18next';
import { isMobileOnly, isTablet } from 'react-device-detect';
import MoreInfoCookieModal from './MoreInfoCookieModal';
import { LocalStorageKeys, readLocalStorage, setLocalStorage } from '../../../utils/localStorageHelper';
export default function CookieBannerModal() {
  const { t } = useTranslation();
  const { setRoute } = useRouteHelper();
  const cookiePolicyPage = setRoute('cookiePolicy');
  const [cookiesAreSet, setcookiesAreSet] = useState(readLocalStorage(LocalStorageKeys.CookiesAreSet, undefined));
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { isOpen: isInfoCookieOpen, onOpen: onInfoCookieOpen, onClose: onCloseInfoCookie } = useDisclosure();
  const {} = useDisclosure();

  const refuseAllCookies = () => {
    setLocalStorage(LocalStorageKeys.CookiesAreSet, true);
    setLocalStorage(LocalStorageKeys.InteractionCookies, false);
    setLocalStorage(LocalStorageKeys.ExperienceCookies, false);
    setLocalStorage(LocalStorageKeys.MeasurementCookies, false);
    onClose();
  };

  const acceptAllCookies = () => {
    setLocalStorage(LocalStorageKeys.CookiesAreSet, true);
    setLocalStorage(LocalStorageKeys.InteractionCookies, true);
    setLocalStorage(LocalStorageKeys.ExperienceCookies, true);
    setLocalStorage(LocalStorageKeys.MeasurementCookies, true);
    onClose();
  };

  const handleAcceptAllInfoModal = () => {
    onCloseInfoCookie();
    acceptAllCookies();
  };

  const handleRefuseAllInfoModal = () => {
    onCloseInfoCookie();
    refuseAllCookies();
  };

  const handleSaveAndContinueInfoModal = () => {
    setLocalStorage(LocalStorageKeys.CookiesAreSet, true);
    onCloseInfoCookie();
    onClose();
  };

  useTimeout(() => {
    setcookiesAreSet(readLocalStorage(LocalStorageKeys.CookiesAreSet, undefined));
  }, 1500);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!cookiesAreSet || cookiesAreSet === 'true') {
        onOpen();
      }
    }, 5000);

    // Clean up function
    return () => clearTimeout(timeoutId);
  }, [cookiesAreSet]);

  const URL = process.env.REACT_APP_FLATE_APP;
  const cookieUrl = `${URL}${cookiePolicyPage}`;

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={isMobileOnly ? 'sm' : isTablet ? 'xl' : '4xl'} closeOnOverlayClick={false} autoFocus={false}>
        <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
        <ModalContent
          px={{ base: '.4em', md: '1em', lg: '1em' }}
          py={{ base: '1em', md: '1em', lg: '2em' }}
          style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            borderRadius: 'none',
            maxWidth: '100%',
            marginBottom: '0',
          }}
        >
          <ModalHeader>
            <HStack fontSize="30px">
              <Text>{t('cookieBanner.title')}</Text> <Icon as={GiCookie} color="#FFB900" fontSize="36px" />
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Stack spacing={8}>
              <Stack spacing="0.5" pe={{ base: '4', md: '0' }}>
                <Text fontWeight="bold" pb="1em">
                  {t('cookieBanner.disclosure')}
                </Text>
                <Text>
                  {t('cookieBanner.weAndParties')}
                  {''}
                  <Link href={cookieUrl} color="secondary.500">
                    {t('cookieBanner.cookiePolicy')}{' '}
                  </Link>
                </Text>
                <Text>{t('cookieBanner.youCan')}</Text>
              </Stack>
              <Flex justifyContent="space-between" flexDir={{ base: 'column', md: 'column', lg: 'row' }}>
                <HStack>
                  <MoreInfoCookieModal
                    isInfoCookieOpen={isInfoCookieOpen}
                    onCloseInfoCookie={onCloseInfoCookie}
                    onInfoCookieOpen={onInfoCookieOpen}
                    handleAcceptAll={handleAcceptAllInfoModal}
                    handleRefuse={handleRefuseAllInfoModal}
                    handleSaveAndContinue={handleSaveAndContinueInfoModal}
                  />
                </HStack>
                <HStack flexDir={{ base: 'column', md: 'column', lg: 'row' }}>
                  <Button
                    colorScheme="secondary"
                    variant="outline"
                    isFullWidth
                    py="1.5em"
                    fontSize={{ base: '14px', lg: '16px' }}
                    mb={{ base: '1em', md: '1em', lg: '0' }}
                    onClick={refuseAllCookies}
                  >
                    {t('cookieBanner.refuse')}{' '}
                  </Button>
                  <Button
                    colorScheme="secondary"
                    variant="solid"
                    isFullWidth
                    py="1.5em"
                    px="4em"
                    onClick={acceptAllCookies}
                    fontSize={{ base: '14px', lg: '16px' }}
                  >
                    {t('cookieBanner.accept')}{' '}
                  </Button>
                </HStack>
              </Flex>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
